import { render } from "./AppLayputBottom.vue?vue&type=template&id=74f87bb1&scoped=true"
import script from "./AppLayputBottom.vue?vue&type=script&lang=js"
export * from "./AppLayputBottom.vue?vue&type=script&lang=js"

import "./AppLayputBottom.vue?vue&type=style&index=0&id=74f87bb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f87bb1"]])

export default __exports__